import { ReactElement, ReactNode } from 'react';

import { icon_arrow_left, icon_arrow_right } from '@gn-audio/icons';

import { stripHtmlTags, useSiteSettings } from '../../../utils';
import useFallbackTranslation from '../../../utils/hooks/useFallbackTranslation';
import { isAuthorized } from '../../../utils/logIn';
import { Button } from '../../Button/Button';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { logIn } from '../../UipMenu/utilities/logIn';
import { useBasket } from '../BasketContext/useBasket';

import styles from '../Basket.module.css';

export type PostLoginActionType = 'transferBasket' | 'checkout';
export interface PostLoginAction {
  type: PostLoginActionType;
  params?: unknown;
}

type MyAccountProps = {
  token: string;
};

const MyAccount = ({ token }: MyAccountProps): ReactElement | null => {
  const { t } = useFallbackTranslation();
  const { closeMyAccountView, basket } = useBasket();
  const { sfcc } = useSiteSettings();

  const logInHandler = async () => {
    if (isAuthorized()) {
      return;
    }
    await logIn([
      {
        type: 'transferBasket',
        params: { basketId: basket?.basket_id, customerId: basket?.customer_info?.customer_id },
      },
      { type: 'checkout' },
    ]);
  };

  const formatSignUpMessage = (): ReactNode => {
    const signUp = t('uip.Signup');
    const signUpNowMessage = stripHtmlTags(t('cart.SignUpNowMessage'));
    const splitSignUpMessage = signUpNowMessage.split(signUp);
    return (
      <>
        {splitSignUpMessage[0]}
        <button onClick={logInHandler} className={styles.signUpNow}>
          {signUp}
        </button>
        {splitSignUpMessage[1]}
      </>
    );
  };

  return (
    <>
      <span className={`${styles.myAccount} mb-6`}>{t('uip.MyJabraAccount')}</span>
      <div className="flex min-w-fit flex-col items-center">
        <form method="POST" action={sfcc?.basketCheckoutUrl}>
          <input type="hidden" name="token" value={token} />
          <input type="hidden" name="action" value="Checkout-Begin" />
          <Button
            variant="secondary"
            size="m"
            icon={<JabraIcon Icon={icon_arrow_right} />}
            iconPlacement="right"
            className="mb-6 w-full"
            type="submit"
          >
            {t('cart.ContinueAsAGuest')}
          </Button>
        </form>

        <Button
          variant="primary"
          size="m"
          icon={<JabraIcon Icon={icon_arrow_right} />}
          iconPlacement="right"
          className={`mb-6 ${styles.loginButton} w-full`}
          onClick={logInHandler}
        >
          {t('uip.SignIn')}
        </Button>
      </div>
      <p className={styles.noAccountText}>{formatSignUpMessage()}</p>
      <Button
        variant="quaternary"
        size="s"
        icon={<JabraIcon Icon={icon_arrow_left} className={'h-[16px] w-[16px]'} />}
        iconPlacement="left"
        onClick={closeMyAccountView}
      >
        {t('cart.Back')}
      </Button>
    </>
  );
};

export default MyAccount;
